module.exports = __webpack_public_path__ + "static/media/react_basic certificate.f7f40b40.png";